import { CourseCertificateEnum } from '../training.interface';

export enum EDegreeTabSectionKey {
  Introduction = 'Degree_Introduction',
  TrainingCertification = 'Degree_TrainingCertification',
  FrequentlyAsks = 'Degree_FrequentlyAsks',
}

export enum EDegreeSubTabSectionKey {
  Introduction = 'Sub_Degree_Introduction',
  Courses = 'Sub_Degree_Courses',
}

export interface IDegreeTabIntroductionSection {
  image: string;
}

export interface IDegreeTabFrequentlyAsksSection {
  questions: {
    question: string;
    answer: string;
  }[];
}

export type TDegreeSubTabIntroductionSection = {
  image: string;
};

export type TDegreeSubTabSectionElement = TDegreeSubTabIntroductionSection;

export type TDegreeSubTabSection = {
  sectionKey: EDegreeSubTabSectionKey;
  elements?: TDegreeSubTabSectionElement;
  isActive: boolean;
};

export type TDegreeTabTrainingCertificationSection = {
  [key in CourseCertificateEnum]: {
    image: string;
    subTab: TDegreeSubTabSection[];
    isActive: boolean;
  };
};

export type TEnterpriseProfileDegreeTabSectionElements =
  | IDegreeTabIntroductionSection
  | IDegreeTabFrequentlyAsksSection
  | TDegreeTabTrainingCertificationSection;

export type TEnterpriseProfileDegreeTabSection = {
  sectionName: string;
  sectionKey: EDegreeTabSectionKey;
  elements?: TEnterpriseProfileDegreeTabSectionElements;
  isActive: boolean;
}[];
